import { PdsWidget } from './pds-widget';
let xlinkns = 'http://www.w3.org/1999/xlink';

const svgIconList: {[path: string]: string} = {
  'behavior-arrow-reverse': '/img/icons/behavior',
  'behavior-checkmark': '/img/icons/behavior',
  'behavior-crown': '/img/icons/behavior',
  'behavior-cup': '/img/icons/behavior',
  'behavior-gift': '/img/icons/behavior',
  'behavior-hammer': '/img/icons/behavior',
  'behavior-hand-heart': '/img/icons/behavior',
  'behavior-hands': '/img/icons/behavior',
  'behavior-heart': '/img/icons/behavior',
  'behavior-ribbon': '/img/icons/behavior',
  'behavior-smile': '/img/icons/behavior',
  'behavior-star': '/img/icons/behavior',
  'behavior-sun': '/img/icons/behavior',
  'behavior-thought-bubble': '/img/icons/behavior',
  'behavior-thumbs-up': '/img/icons/behavior'
};

//key: old name => value: existing name
const deprecatedNameMap: {[oldName: string]: string} = {
  'edit': 'pencil',
  'star-f': 'star',
  'star-s': 'star',
  'ask-question': 'hand',
  'attachment-f': 'paperclip',
  'audio': 'speaker',
  'bookmark-add': 'bookmark-plus',
  'bookmark-delete': 'bookmark-minus',
  'calculator-f': 'calculator',
  'calendar-f': 'calendar',
  'calendar-s': 'calendar',
  'calendar2': 'calendar',
  'calendar-events': 'calendar-star',
  'calendar-day': 'calendar-day-1',
  'camera-f': 'camera',
  'checkmark-circle': 'checkmark-alt',
  'checkmark-square': 'checkmark-alt2',
  'dashboard-s': 'dashboard',
  'dashboard-f': 'dashboard',
  'attendance-f': 'desk',
  'download-s': 'download',
  'erase': 'backspace',
  'filter-remove': 'filter-x',
  'grading': 'calculator-file',
  'more': 'ellipsis',
  'options-f': 'ellipsis',
  'pen-f': 'pencil-note',
  'logout': 'signout',
  'standards': 'target',
  'trash-s': 'trash',
  'caret-down-square': 'caret-square-down',
  'pointer-up': 'chevron-up',
  'pointer-up-2': 'chevron-up',
  'pointer-right': 'chevron-right',
  'pointer-down': 'chevron-down',
  'pointer-down-2': 'chevron-down',
  'pointer-up-left': 'chevron-left',
  'pointer-left-circle-s': 'chevron-left',
  'pointer-left': 'chevron-left',
  'pointer-right-circle-s': 'chevron-right',
  'drop-down-arrow': 'chevron-down',
  'arrow-to-bottom': 'arrow-down-line',
  'arrow-to-top': 'arrow-up-line',
  'join': 'arrows-inward',
  'split': 'arrows-outward',
  'arrow-horizontal': 'arrows-horizontal',
  'arrow-vertical': 'arrows-vertical',
  'expand': 'arrows-expand',
  'arrow-collapse': 'arrows-collapse',
  'arrow-expand': 'arrows-expand',
  'collapse': 'arrows-collapse',
  'move': 'arrows-move',
  'left-right-arrows-f': 'arrows-left-right',
  'arrows-up-down': 'arrows-down-up',
  'arrow-split': 'arrows-split',
  'disaggregate': 'arrows-apart',
  'arrow-circle-down': 'behavior-circle-down',
  'arrow-circle-up': 'behavior-circle-up',
  'behavior-badge-1': 'behavior-sun',
  'behavior-badge-2': 'behavior-cup',
  'behavior-badge-3': 'behavior-gift',
  'behavior-badge-4': 'behavior-ribbon',
  'behavior-badge-5': 'behavior-crown',
  'behavior-badge-6': 'behavior-heart',
  'behavior-badge-7': 'behavior-checkmark',
  'behavior-badge-8': 'behavior-thumbs-up',
  'behavior-badge-9': 'behavior-star',
  'behavior-badge-10': 'behavior-smile',
  'behavior-collaborate': 'behavior-thought-bubble',
  'behavior-collaborative	': 'behavior-thought-bubble',
  'behavior-helpful': 'behavior-hands',
  'behavior-kind': 'behavior-hand-heart',
  'behavior-hardworking': 'behavior-hammer',
  'behavior-hardwork': 'behavior-hammer',
  'behavior-turned-that-around': 'behavior-arrow-reverse',
  'behavior-turn-that-around': 'behavior-arrow-reverse',
  'comments': 'message-bubble',
  'communication-s': 'message-bubbles',
  'message-bubbles-f': 'message-bubbles',
  'discussion': 'message-bubbles-stack',
  'message-fail': 'message-bubble-fail',
  'checkmark-circle-f': 'checkmark-alt',
  'checkmark-circle-s': 'checkmark-alt',
  'circle-alert-s': 'exclamation',
  'circle-2': 'circle',
  'circle-subtract': 'minus-alt',
  'close-s': 'x-alt',
  'disable': 'backslash',
  'circle-slash': 'slash-alt',
  'help-f': 'help',
  'help-s': 'help',
  'question-o': 'help',
  'question-circle-s': 'help',
  'plus-f': 'plus-alt',
  'non-editable': 'pencil-ban',
  'non editable': 'pencil-ban',
  'plus-s': 'plus-alt',
  'color-levels-1': 'color-grid',
  'color-levels-2': 'color-grid-greyscale',
  'assessment-preview': 'clipboard-magnifing-glass',
  'assessment-results': 'clipboard-checkmark',
  'assessment': 'clipboard',
  'assignment-add': 'page-plus',
  'assignment-f': 'page',
  'bubble-sheet': 'page-dots-pencil',
  'draft': 'document-pencil',
  'evaluation': 'clipboard-checkmark-empty',
  'key-type-assessment': 'clipboard-key',
  'note-pad-f': 'note',
  'plan': 'clipboard-folder',
  'publish': 'document-checkmark',
  'report': 'document-list',
  'roster': 'document-people',
  'scan-compatible': 'page-dots-checkmark',
  'mail-group': 'envelopes',
  'message': 'envelope',
  'unread': 'envelope-notification',
  'settings-s': 'gear',
  'settings-f': 'gear',
  'settings-bottom-f': 'gear',
  'process': 'gears',
  'unprocess': 'gears-x',
  'bullet-list': 'list',
  'list-view': 'list',
  'app-switcher': 'tiles-9',
  'score-inspector': 'number-pad',
  'locker': 'pad-lock',
  'unlock': 'lock-open',
  'security': 'lock',
  'zoom': 'zoom-in',
  'fast-forward': 'media-fast-forward',
  'fast-rewind': 'media-rewind',
  'listen': 'media-listen',
  'media-controls-pause': 'media-pause',
  'media-controls-play': 'media-play',
  'rewind': 'media-rewind',
  'skip-backwards': 'media-skip-backward',
  'skip-forward': 'media-skip-forward',
  'stop': 'media-stop',
  'video-f': 'media-video',
  'close-circle-f': 'x-alt',
  'close-circle-s': 'x-alt',
  'complete': 'proctoring-complete',
  'class': 'computer-layout',
  'admin-school': 'school-gear',
  'admin-system': 'user-gear',
  'dropped-student-f': 'user-desk-minus',
  'empty-student': 'user-desk',
  'notifications-student': 'user-desk',
  'group-add': 'users-group-plus',
  'group': 'users-group',
  'meeting': 'users-message-bubbles',
  'members': 'users',
  'person-card-s': 'user-card',
  'student-added': 'user-desk-plus',
  'student-f': 'user-desk',
  'student-group-private': 'users-desks',
  'student-group-published': 'users-desks-checkmark',
  'teacher': 'user-board',
  'user-add': 'user-plus',
  'notifications-parent': 'user-shadow',
  'user-f': 'user',
  'user-s': 'user',
  'user-remove': 'user-x',
  'onenote': 'MS-onenote',
  'Google': 'google',
  'excel': 'xls',
  'alert-balance-f': 'dollar-sign',
  'alert-birthday-s': 'cake',
  'alert-discipline-s': 'scale',
  'alert-medical': 'medical',
  'alert-other-s': 'exclamation',
  'alert-parent-s': 'user-shadow',
  'alert': 'bell',
  'announcement': 'megaphone',
  'bar-graph-f': 'chart-alt',
  'book-f': 'book',
  'chart-kpi': 'chart-upward',
  'clock-add': 'clock-plus',
  'clock-late': 'clock-alt',
  'clock-s': 'clock',
  'external-link': 'external',
  'generic': 'stack',
  'generic-f': 'stack',
  'global-f': 'globe',
  'global-s': 'globe',
  'view': 'eye',
  'hide': 'eye-slash',
  'play': 'controller',
  'products': 'box',
  'repository': 'box-alt',
  'rocket-f': 'rocket',
  'rubric': 'tiles-8',
  'shop': 'basket'
};

export class PdsIcon extends PdsWidget {
  is = 'pds-icon';
  name: string;
  isSvgIcon: boolean;
  path: string;
  scopeClass: string;  //scopeClass should be used in other polymer components that use pds-icon to make sure the correct class is applied
  //querySelectorAll: Function;

  properties = {
    name: {
      isSvgIcon: {isSvgIcon: String, value: ''},
      observer: '_nameObserver'
    }
  };

  contentObserver: any;

  attached(): void {
    super.attached();
  }

  _nameObserver(): void {
    let iconName = this.name;
    if (deprecatedNameMap.hasOwnProperty(iconName)) {
      iconName = deprecatedNameMap[ iconName ];
    }

    if (svgIconList.hasOwnProperty(iconName)) {
      this.path = svgIconList[iconName];
      this.isSvgIcon = true;
      let svg = this.querySelector('svg');
      svg.style.display = 'none';
    } else {
      let elements = this.querySelectorAll('use');
      if (elements != null && elements.length === 2) {
        elements[ 0 ].setAttributeNS(xlinkns, 'xlink:href', '#' + iconName);
        elements[ 1 ].setAttributeNS(xlinkns, 'xlink:href', this.pds.svgSpritePath + '#' + iconName);
      }
    }
  }
}
